import {getErrorMessage} from "../../../utils/serverErrorCheck";
import { fork, takeEvery, all } from 'redux-saga/effects';
import {
    LogControllerDtoPilotDisassembleLogListRequest,
    LogControllerDtoPilotDisassembleLogListResponse,
    LogControllerDtoPilotEquipLogListRequest,
    LogControllerDtoPilotEquipLogListResponse,
    LogControllerDtoPilotPromotionLogListRequest,
    LogControllerDtoPilotPromotionLogListResponse,
    LogControllerDtoPilotSkillChangeLogListRequest,
    LogControllerDtoPilotSkillChangeLogListResponse,
    PerplayLogApi
} from "../../models/src";
import config from "../../../config/config";
import {
    PILOT_DISASSEMBLE_LOG_LIST_REQUEST,
    PILOT_EQUIP_LOG_LIST_REQUEST, PILOT_PROMOTION_LOG_LIST_REQUEST,
    PILOT_SKILL_CHANGE_LOG_LIST_REQUEST
} from "../../constants/log/pilotLogConstant";

const api = new PerplayLogApi(config.API_CLIENT);

function* pilotEquipLogListRequest(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoPilotEquipLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = Number(payload.accountNo);
        requestData.nftUid = payload.nftUid;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayLogPilotEquipLogListPost({ logControllerDtoPilotEquipLogListRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, LogControllerDtoPilotEquipLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }
        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* pilotSkillChangeLogListRequest(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoPilotSkillChangeLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = Number(payload.accountNo);
        requestData.nftUid = payload.nftUid;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayLogPilotSkillChangeLogListPost({ logControllerDtoPilotSkillChangeLogListRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, LogControllerDtoPilotSkillChangeLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }
        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* pilotDisassembleLogListRequest(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoPilotDisassembleLogListRequest();

        console.log(payload);
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = Number(payload.accountNo);
        requestData.nftUid = payload.nftUid;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayLogPilotDisassembleLogListPost({ logControllerDtoPilotDisassembleLogListRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, LogControllerDtoPilotDisassembleLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* pilotPromotionLogListRequest(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoPilotPromotionLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = Number(payload.accountNo);
        requestData.nftUid = payload.nftUid;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayLogPilotPromotionLogListPost({ logControllerDtoPilotPromotionLogListRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, LogControllerDtoPilotPromotionLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }
        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* pilotLogListRootSaga() {
    yield all([
        takeEvery(PILOT_EQUIP_LOG_LIST_REQUEST, pilotEquipLogListRequest),
        takeEvery(PILOT_SKILL_CHANGE_LOG_LIST_REQUEST, pilotSkillChangeLogListRequest),
        takeEvery(PILOT_DISASSEMBLE_LOG_LIST_REQUEST, pilotDisassembleLogListRequest),
        takeEvery(PILOT_PROMOTION_LOG_LIST_REQUEST, pilotPromotionLogListRequest),
    ])
}

const pilotLogSaga = [
    fork(pilotLogListRootSaga),
];

export default pilotLogSaga;
